import {
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { IonMenu, NavController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { LoginService } from 'src/app/services/login.service';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.page.html',
  styleUrls: ['./admin.page.scss'],
})
export class AdminPage implements OnInit, OnDestroy {
  @ViewChild('menuAdmin', { static: true }) menuAdmin: any;
  public logo: any = undefined;
  public ocult = true;
  public listOptions = [
    {
      icon: './assets/iconsAdmin/Usuario.svg',
      route: '/admin/users',
      text: 'Usuarios',
    },
    {
      icon: './assets/iconsAdmin/categorias.svg',
      route: '/admin/categories',
      text: 'Categorias',
    },
    {
      icon: './assets/icons/prod.svg',
      route: '/admin/products',
      text: 'Productos',
    },
    {
      icon: './assets/iconsAdmin/galeria.svg',
      route: '/admin/galeries',
      text: 'Galerias',
    },
    {
      icon: './assets/iconsAdmin/pagos.svg',
      route: '/admin/paylist',
      text: 'Pagos',
    },
    {
      icon: './assets/iconsAdmin/banner.svg',
      route: '/admin/banner',
      text: 'Banner',
    },
    {
      icon: './assets/iconsAdmin/moneda.svg',
      route: '/admin/currencies',
      text: 'Monedas',
    },
    {
      icon: './assets/iconsAdmin/pricetag-outline.svg',
      route: '/admin/sponsor',
      text: 'Patrocinios',
    },
    {
      icon: './assets/iconsAdmin/bancos.svg',
      route: '/admin/gains',
      text: 'Metricas',
    },
    {
      icon: './assets/iconsAdmin/terminos.svg',
      route: '/admin/terms',
      text: 'Terminos',
    },
    {
      icon: './assets/iconsAdmin/card-outline.svg',
      route: '/admin/methods',
      text: 'Metodos',
    },
    {
      icon: './assets/iconsAdmin/apps-outline.svg',
      route: '/admin/catalogues',
      text: 'Catalogos',
    },
    {
      icon: './assets/iconsAdmin/email.svg',
      route: '/admin/contacts',
      text: 'Contacto',
    },
    {
      icon: './assets/iconsAdmin/stats-chart-outline.svg',
      route: '/admin/ads',
      text: 'Anuncios',
    },
    {
      icon: './assets/iconsAdmin/people-outline.svg',
      route: '/admin/branch',
      text: 'Sucursales',
    },
    {
      icon: './assets/iconsAdmin/cloud-outline.svg',
      route: '/admin/load',
      text: 'Carga masiva',
    },
    {
      icon: './assets/iconsAdmin/calendar-number-outline.svg',
      route: '/admin/meeting',
      text: 'Citas',
    },
    {
      name: 'gift-outline',
      route: '/admin/gift-card',
      text: 'Gift Card / Cupones',
    },
    {
      name: 'calendar-outline',
      route: '/admin/subscriptions',
      text: 'Suscripciones',
    },
    {
      name: 'alarm-outline',
      route: '/admin/attention-schedule',
      text: 'Horario de atención',
    },
    {
      name: 'pin-sharp',
      route: '/admin/group',
      text: 'Adicionales del Producto',
    },
    {
      name: 'brush-outline',
      route: '/admin/special-requests',
      text: 'Peticiones especiales',
    },
    {
      name: 'cash-outline',
      route: '/admin/payment-proof',
      text: 'Comprobante de abono',
    },
    {
      name: 'mail-outline',
      route: '/admin/mail-view',
      text: 'Vistas de email',
    },
    {
      name: 'id-card-outline',
      route: '/admin/disccount-per-users',
      text: 'Descuento por cliente',
    },
    {
      name: 'chatbox-outline',
      route: '/admin/suggestions-chat',
      text: 'Chat',
    },
    {
      name: 'language-outline',
      route: '/admin/languages',
      text: 'Idiomas',
    },
    {
      name: 'radio-outline',
      route: '/admin/virtual-class',
      text: 'Aula Virtual',
    },
    {
      name: 'push-outline',
      route: '/admin/wallet-cash-out',
      text: 'Retiros de Wallet',
    },
  ];

  private _subscription: Subscription = new Subscription();

  constructor(
    private navCtrol: NavController,
    private paramSv: ParamServicesService,
    private renderer: Renderer2,
    public loginSv: LoginService
  ) {}

  ngOnInit(): void {
    const menu: IonMenu = this.menuAdmin;
    this._subscription.add(
      menu.ionWillOpen.subscribe(() => {
        this.openMenu();
      })
    );

    this._subscription.add(
      menu.ionDidClose.subscribe(() => {
        this.closeMenu();
      })
    );

    if (this.paramSv.availableViews) {
      this.hiddeViews(this.paramSv.availableViews.value);
    }

    if (this.paramSv.styles) {
      this.setCartStyle();
    }
    this.comprobeModuleNames();
    this._subscription.add(
      this.paramSv.emitImagesObs.subscribe((item: any) => {
        if (item.name === 'Login') {
          this.logo = this.paramSv.savedLogo.find(
            (item) => item.name === 'Login'
          );
        } else if (item.name === 'views') {
          this.hiddeViews(item.value);
          this.listOptions = this.fixOrdenList(this.listOptions);
        } else if (item === 'finish') {
          this.setCartStyle();
          this.comprobeModuleNames();
        }
      })
    );
    this.listOptions = this.fixOrdenList(this.listOptions);
  }

  comprobeModuleNames() {
    if (this.paramSv.modulesNames.length) {
      this.paramSv.modulesNames.forEach((module) => {
        let option = this.listOptions.find((item) => item.text === module.name);
        if (option && module.newName) {
          option.text = module.newName;
        }
      });
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  fixOrdenList(data: any[]): any[] {
    data.sort((a, b) => {
      if (a.text > b.text) {
        return 1;
      }
      if (a.text < b.text) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });

    if (!!data.find((item) => item.text === 'Salir')) {
      data = data.filter((item) => item.text !== 'Salir');
    }

    data.push({
      icon: './assets/iconsAdmin/salir.svg',
      route: '/home',
      text: 'Salir',
    });

    return data;
  }

  hiddeViews(value) {
    const views: any[] = value.value;
    views.map((item) => {
      const findRoute = this.listOptions.findIndex(
        (view) => view.route === item.route
      );
      if (findRoute >= 0 && !item.visible) {
        this.listOptions.splice(findRoute, 1);
      }
    });
  }

  setCartStyle() {
    const cart = this.paramSv.styles.find(
      (item) => item.text === 'Carrito'
    )?.selected;
    const productSection = this.listOptions.find(
      (x) => x.route === '/admin/products'
    );
    if (productSection) {
      productSection.icon = './assets/icons/' + (cart || 'carrito2.svg');
    }
  }

  goTo(url) {
    this.navCtrol.navigateForward(url);
  }

  openMenu() {
    if (this.ocult === true) {
      this.renderer.addClass(this.menuAdmin.el, 'menuOpen');
      setTimeout(() => {
        this.ocult = false;
      }, 100);
    }
  }

  closeMenu() {
    if (this.ocult === false) {
      this.renderer.removeClass(this.menuAdmin.el, 'menuOpen');
      setTimeout(() => {
        this.ocult = true;
      }, 100);
    }
  }
}
